import { render, staticRenderFns } from "./Shansuan.vue?vue&type=template&id=4c61104f&scoped=true&"
import script from "./Shansuan.vue?vue&type=script&lang=ts&"
export * from "./Shansuan.vue?vue&type=script&lang=ts&"
import style0 from "./Shansuan.vue?vue&type=style&index=0&id=4c61104f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c61104f",
  null
  
)

component.options.__file = "Shansuan.vue"
export default component.exports